/** @format */

export const PLATE_PROVINCE_STRING = '京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领临';
